import { TextButton } from '@oneaudi/unified-web-components';
import { useCallback } from 'react';
import { StyledSection } from '~/app/compositions/content/eec/styles/eec-label-section-de-style';
import { useI18n } from '~/app/i18n/i18n';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { EventAction } from '~/app/tracking/feld-m-types';
import { DATA_TEST_ID } from '~/test/data-test-id';

export function EecLabelSectionDE({ url, pdfURL }: { url: string; pdfURL: string }) {
	const { i18n } = useI18n();

	const handleOnClick = useCallback(() => {
		appTrackingService.summaryClickEvent({
			eventAction: EventAction.Download,
			eventName: 'configurator (consumption & emission) - click to download consumption & emission data',
			componentName: 'configurator-consumption-and-emission',
			label: i18n('ngc.technicalData.envkv.pdf.label'),
			targetURL: pdfURL || '',
			elementName: 'button',
		});
	}, [i18n, pdfURL]);

	return (
		<StyledSection data-testid={DATA_TEST_ID.SUMMARY_EEC_CONTAINER}>
			{/* eslint-disable jsx-a11y/no-noninteractive-tabindex */}
			<div tabIndex={0}>
				<div>
					<img className="label-image" src={url} alt="Energielabel" aria-label="Energie-Label" />
				</div>

				{pdfURL && (
					<TextButton
						onClick={handleOnClick}
						href={pdfURL}
						target={'_blank'}
						icon={'document-pdf'}
						variant="secondary"
						isFullWidth
						aria-label={i18n('ngc.technicalData.envkv.pdf.label')}>
						{i18n('ngc.technicalData.envkv.pdf.label')}
						<span className="sr-only"> . {i18n('ngc.a11y.openInNewTab')}</span>
					</TextButton>
				)}
			</div>
		</StyledSection>
	);
}
